import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { TableBaseStyle, StudySettingStyle } from './StudySettingStyle';
import { STUDY_SET_2 } from './StudySetting';
import NumericEntry_inputEx from './../../../atoms/Input/NumericEntry_inputEx';
import { useTranslation } from 'react-i18next';

type StudySetting2EditBodyProps = {
  studySet2List: STUDY_SET_2[];
  onChangeData: (targetRow: STUDY_SET_2) => void;
};

const StudySetting2EditBody: React.FC<StudySetting2EditBodyProps> = (props) => {
  const tableStyle = TableBaseStyle();
  const studySettingStyle = StudySettingStyle();

  const [studySetting2, setStudySetting2] = useState<STUDY_SET_2[]>(props.studySet2List); //データ初期値
  const [isEdit, setIsEdit] = useState<boolean>(false); //変更フラグ データを編集したらtrue
  const { t, i18n } = useTranslation();

  /**
   * データ変更通知
   */
  useEffect(() => {
    //データ初期値にセットされている内容を再描画時に変えたい場合、useEffectが必要
    console.debug(['StudySetting2EditBody - useEffect props.studySet2List', props.studySet2List]);
    setStudySetting2([...props.studySet2List]);
    setIsEdit(false);
  }, [props.studySet2List]);
  /**
   * 上位にデータ変更通知
   * @param editRow　編集対象データ
   * @param isEdit 編集フラグ
   * @returns
   */
  const onChangeData = (editRow: STUDY_SET_2, editFlg: boolean) => {
    if (editFlg) {
      //console.debug(['onChangeData - editRow,baseData', editRow, props.studySet1]);
      props.onChangeData(editRow);
    }
  };
  /**
   * 係数閾値の名称取得
   */
  const getItemName = (index: number):string =>{
    if(index == 0){
      return t('StudySetting2EditBody.振動係数閾値', '振動係数閾値');
    }
    else{
      return t('StudySetting2EditBody.電流係数閾値', '電流係数閾値');
    }
  };
  return (
    <Paper elevation={3} classes={{ root: studySettingStyle.paperRoot }}>
      <Table stickyHeader aria-label="a dense table">
        <TableBody>
          <TableRow>
            {studySetting2.map((row, index) => {
              return (
                <>
                  <TableCell className={tableStyle.headerCell}>
                    {getItemName(index)}
                  </TableCell>
                  <TableCell className={tableStyle.bodyCell} width={150}>
                    <NumericEntry_inputEx
                      className={tableStyle.textField}
                      value={row.THR_NUM ?? 0}
                      minValueLimit={0}
                      maxValueLimit={0.99}
                      fixed={2}
                      onChange={(val) => {
                        if (props.studySet2List[index].THR_NUM !== val) {
                          row.THR_NUM = val;
                          onChangeData(row, true);
                          console.debug(['NumericEntry_inputEx - onChange - THR_NUM', val, studySetting2]);
                        }
                      }}
                    />
                  </TableCell>
                </>
              );
            })}

          </TableRow>
        </TableBody>
      </Table>
    </Paper>
  );
};

export default StudySetting2EditBody;
